module.exports = __webpack_public_path__ + "static/media/RemoteHealthMonitoring.3ca1989b.png";